import { QUERY_BOUND_POLICIES } from '../../constants/actions/policies';

export function queryBoundPolicies(payload) {
    return {
        type: QUERY_BOUND_POLICIES,
        payload,
    };
}
